import "../pages.scss"
import { ZonasState } from '../../context/zonasentrega/ZonasState';
import Datatable from "./zonasTable/Datatable"

const ZonasPage = () => {
  return (
    <>
      <ZonasState>
        <Datatable />
      </ZonasState>

    </>
  )
}

export default ZonasPage